<template>
  <input
    v-bind="$attrs"
    ref="focusInput"
    :type="type"
    :placeholder="placeholder"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
  />
  <slot />
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "text",
    },
    modelValue: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    isFocusInStart: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    if (this.$props.isFocusInStart) {
      this.$refs.focusInput.focus();
    }
  },
};
</script>

<style lang="scss" scoped>
input {
  border-radius: 11px;
  background: #e4e2f4ff;
  width: 100%;
  height: 50px;
  margin-bottom: 8px;
  font-family: Gilroy;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 135.7%;
  color: black;
  border: none;
  padding-left: 22px;
}
</style>
